module.exports = __webpack_public_path__ + "static/media/13.28b2c3be.jpg";